import React from 'react';
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';

function OtherTextInput(props) {
  const {
    otherChecked,
    otherText,
    onChangeOtherText
  } = props;

  return(
  <FormGroup className="ms-4">
    <Row>
    <Col md="6">
    <Label for="other-text" className="visually-hidden">
      Please specify:
    </Label>
    <Input
      id="other-text"
      value={otherText}
      onChange={onChangeOtherText}
      disabled={!otherChecked}
      // placeholder="please specify"
      name="other-text"
      type="textfield"
    />
    </Col>
    </Row>
  </FormGroup>
  );
}

export default OtherTextInput;
